import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-speedtest',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Speedtest icon</title><path d="M11.628 16.186l-2.047-2.14 6.791-5.953 1.21 1.302zm8.837 6.047c2.14-2.14 3.535-5.117 3.535-8.466 0-6.604-5.395-12-12-12s-12 5.396-12 12c0 3.35 1.302 6.326 3.535 8.466l1.674-1.675c-1.767-1.767-2.79-4.093-2.79-6.79A9.568 9.568 0 0 1 12 4.185a9.568 9.568 0 0 1 9.581 9.581c0 2.605-1.116 5.024-2.79 6.791Z"/></svg>`,
    styles: []
})
export class SimpleIconsSpeedtestComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#141526';
    @Input() className: string = 'simple-icons-speedtest'
    constructor() {}
    ngOnInit(): void {}
}
